/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateOtherPrintDto
 */
export interface CreateUpdateOtherPrintDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    examId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateOtherPrintDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    otherPrintDefId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    userUID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    objective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDto
     */
    directsTo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOtherPrintDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOtherPrintDto
     */
    withoutSign?: boolean | null;
}

/**
 * Check if a given object implements the CreateUpdateOtherPrintDto interface.
 */
export function instanceOfCreateUpdateOtherPrintDto(value: object): value is CreateUpdateOtherPrintDto {
    return true;
}

export function CreateUpdateOtherPrintDtoFromJSON(json: any): CreateUpdateOtherPrintDto {
    return CreateUpdateOtherPrintDtoFromJSONTyped(json, false);
}

export function CreateUpdateOtherPrintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateOtherPrintDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examId': json['examId'] == null ? undefined : json['examId'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'otherPrintDefId': json['otherPrintDefId'] == null ? undefined : json['otherPrintDefId'],
        'userUID': json['userUID'] == null ? undefined : json['userUID'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'objective': json['objective'] == null ? undefined : json['objective'],
        'directsTo': json['directsTo'] == null ? undefined : json['directsTo'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
    };
}

export function CreateUpdateOtherPrintDtoToJSON(value?: CreateUpdateOtherPrintDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examId': value['examId'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'otherPrintDefId': value['otherPrintDefId'],
        'userUID': value['userUID'],
        'comments': value['comments'],
        'objective': value['objective'],
        'directsTo': value['directsTo'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
    };
}

